import axiosInstance from '../instance/AxiosInstance';
export const invoiceViewEffect = async (invoiceId) => {
  try {
    const response = await axiosInstance.get(
      `/invoice/getinvoice?invoice_id=${invoiceId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to Fetch Invoice';
  }
};
export const invoiceViewAllEffect = async () => {
  try {
    const response = await axiosInstance.get(
      `/reports/getbookingservicereports?pagination_required=false&pageNo=1&pagesize=10`
    );

    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to Fetch Invoice';
  }
};
export const customerInvoiceViewAllEffect = async (customerId) => {
  try {
    const response = await axiosInstance.get(
      `/reports/bookinggetbycustomer?pagination_required=false&pageNo=1&pagesize=10&customer_id=${customerId}`
    );

    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to Fetch Invoice';
  }
};
export const vendorInvoiceViewAllEffect = async (vendorId) => {
  try {
    const response = await axiosInstance.get(
      `/reports/bookinggetbycustomer?pagination_required=false&pageNo=1&pagesize=10&vendor_id=${vendorId}`
    );

    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Failed to Fetch Invoice';
  }
};
